import React from "react";
import { Fieldset } from 'primereact/fieldset';
const Help = () => {
  return (
    <div className="card">
      <Fieldset legend="Important Business Function Links">
        <ul>
          <p title="QAG (BE)"><a style={{ fontSize: '16px' }} href="mailto:qag@espire.com"><i class="pi pi-envelope mr-4"></i>qag@espire.com</a></p>
          <p title="HR"><a style={{ fontSize: '16px' }} href="mailto:hrd@espire.com"><i class="pi pi-envelope mr-4"></i>hrd@espire.com</a></p>
          <p title="Finance"><a style={{ fontSize: '16px' }} href="mailto:finance@espire.com"><i class="pi pi-envelope mr-4"></i>finance@espire.com</a></p>
          <p title="MIS"><a style={{ fontSize: '16px' }} href="mailto:mis@espire.com"><i class="pi pi-envelope mr-4"></i>mis@espire.com</a></p>
          <p title="GUR FAC"><a style={{ fontSize: '16px' }} href="mailto:gur.fac@espire.com"><i class="pi pi-envelope mr-4"></i>gur.fac@espire.com</a></p>
        </ul>
      </Fieldset>
    </div>
  );
};

export default Help;
